import MapMenu from '../lib/map_menu';

export default class TagLayer {
	constructor(tag) {
		this.tag = tag;
		this.checkboxEl = document.getElementById('tag-layer-' + this.tag.id);
		this.visible = false;
	}

	add(map) {
		let url = W.api_root + 'tags/' + encodeURIComponent(this.tag.id) + '.geojson';

		if (!map.getSource('tag-source-' + this.tag.id)) {
			map.addSource('tag-source-' + this.tag.id, {
				type: 'geojson',
				data: url,
			});
		}

		map.addLayer({
			id: 'tag-layer-' + this.tag.id,
			type: 'symbol',
			source: 'tag-source-' + this.tag.id,
			layout: {
				'icon-image': 'marker-housing', // if we add tag layers, need to revise
				'icon-offset': [0, 0],
				'icon-anchor': 'bottom',
				'icon-size': 1.5,
				'icon-allow-overlap': true,
				'icon-ignore-placement': true,
			},
		});
		this.visible = true;
		W.LayerUtils.setView('tag-layer-' + this.tag.id);
		MapMenu.hide();
	}

	remove() {
		W.map.removeLayer('tag-layer-' + this.tag.id);
		this.visible = false;
	}
}
